import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions')({
  beforeLoad: () => getTitleContextSlice('Content Permissions'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
